













































































import { Component, Prop, Vue } from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import GlobalDialog from '../../GlobalDialog.vue';
import CatalogProductReviewForm from './ProductReviewForm.vue';

interface Review {
  content: string;
  created_at: number;
  nickname: string;
  rating: number;
  sponsored?: boolean;
}

@Component({
  name: 'catalog-product-reviews',
  components: {
    GlobalDialog,
    CatalogProductReviewForm,
    ...ServiceContainer().getComponents(),
  },
})

export default class extends Vue {
  @Prop({ required: true }) readonly productRating: number;
  @Prop({ required: true }) private productReviews!: Array<Review>;
  @Prop({ required: false }) private productName!: string;
  @Prop({ required: false }) private productId!: string;
  @Prop({ required: false }) private productReviewCount!: number;

  private visibleReviews: number = 1;
  private reviewStep: number = 3;
  private showAllReviews: boolean = false;

  private get orderId(): string | null {
    const params = new URLSearchParams(window.location.search);
    let orderId = params.get('orderId');

    if (!orderId) {
      const match = window.location.href.match(/orderId=(\d+)/);
      orderId = match ? match[1] : null;
    }

    return orderId;
  }

  get filteredReviews(): Array<Review> {
    return this.productReviews.filter(review => review.content && review.content.trim() !== '');
  }

  private formattedAverageScore(score: number): string {
    return (score / 10).toFixed(1);
  }

  private formatDate(date: number): string {
    return new Date(date * 1000).toLocaleDateString().replace(/\//g, '-');
  }

  private get isMobile(): boolean {
    return !!this.$mobileDetect.mobile();
  }

  private showMoreReviews(): void {
    this.visibleReviews = Math.min(this.visibleReviews + this.reviewStep, this.productReviews.length);
  }

  private showLessReviews(): void {
    this.visibleReviews = this.isMobile ? 1 : 3;
  }

  private get canShowMore(): boolean {
    return this.visibleReviews < this.productReviews.length;
  }

  private get canShowLess(): boolean {
    return this.visibleReviews > (this.isMobile ? 1 : 3);
  }

  private get shouldShowMoreReviewsButton(): boolean {
    return this.isMobile || this.productReviews.length > 3;
  }

  private openDialog(): void {
    const dialog = this.$refs.dialog as Vue & { openDialog: () => void };
    if (dialog && typeof dialog.openDialog === 'function') {
      dialog.openDialog();
    } else {
      console.error('Dialog reference or openDialog method not found');
    }
  }

  private mounted(): void {
    this.visibleReviews = this.isMobile ? 1 : Math.min(3, this.productReviews.length);
    this.showAllReviews = this.visibleReviews >= this.productReviews.length;
  }
}
